import React from 'react';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

//function Breadcrumb({categories, idcategory}) {
function Breadcrumb({url, text_before, text_active, level}) {

    /*return (
        <div class="banner-wrapper no_background">
            <div class="banner-wrapper-inner">
                <div class="breadcrumb-trail breadcrumbs">
                    <ul class="trail-items breadcrumb">
                        <li class="trail-item trail-begin"><a href="/"><span>Home</span></a></li>
                        <li class="trail-item"><a href="#"><span>Blog</span></a></li>
                        <li class="trail-item trail-end active"><span>Single Post.</span></li>
                    </ul>
                </div>
            </div>
        </div>
    );*/

    return (
        <div className="banner-wrapper no_background">
            <div className="banner-wrapper-inner">
                <div className="breadcrumb-trail breadcrumbs">
                    <ul className="trail-items breadcrumb">
                        <li className="trail-item trail-begin"><a href="/"><span>Inicio</span></a></li>
                        {
                            level ?
                            <li className="trail-item trail-begin"><a href={url}><span>{text_before}</span></a></li>
                            :
                            null
                        }
                        <li className="trail-item trail-end active"><span>{text_active}.</span></li>
                    </ul>
                </div>
            </div>
            <br />
        </div>
    );
}

export default Breadcrumb;